<form [formGroup]="postingForm">
  <div layout-horizontal>
    <div layout-verical layout-flex-1 class="column">
      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.location' | translate }}

          @if (posting) {
            <rt-icon-help
              [rtTooltip]="
                'rti.werken_in_een_hotel.update_posting.modal.location_tooltip' | translate
              "
              margin-left-small-x
            ></rt-icon-help>
          }
        </rt-label>
        <rt-select
          formControlName="locationId"
          [options]="locationOptions"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        >
        </rt-select>
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.main_function_category' | translate }}
        </rt-label>
        <rt-select
          formControlName="mainFunctionCategoryId"
          [options]="state.jobCategories"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        >
        </rt-select>
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.function_characteristic' | translate }}
        </rt-label>
        <rt-select
          formControlName="functionCharacteristicId"
          [options]="state.features"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        >
        </rt-select>
      </rt-form-field>
    </div>

    <div layout-verical layout-flex-1 margin-left class="column">
      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.contact' | translate }}
        </rt-label>
        <rt-select
          formControlName="contactId"
          [options]="state.contacts"
          [hasSearch]="false"
          [hasInputTrigger]="true"
          [placeholder]="'rtu.ui.select.none' | translate"
        >
        </rt-select>
      </rt-form-field>

      <rt-form-field margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.extra_function_category' | translate }}
        </rt-label>
        <rt-select
          formControlName="extraFunctionCategoryId"
          [options]="state.jobCategories"
          [hasSearch]="false"
          [placeholder]="'rtu.ui.select.none' | translate"
        >
        </rt-select>
      </rt-form-field>

      <rt-form-field [required]="!postingForm.get('employmentIds')!.value.length" margin-bottom>
        <rt-label>
          {{ 'rti.werken_in_een_hotel.create_posting.modal.employment_type' | translate }}
        </rt-label>
        @if (state.employmentTypes.length > 0) {
          <rti-simple-multiselect
            [control]="$any(postingForm).get('employmentIds')"
            [options]="state.employmentTypes"
          ></rti-simple-multiselect>
        }

        @if (state.employmentTypes.length === 0) {
          <rti-simple-multiselect
            [control]="emptyEmploymentIdsControl"
            [options]="[]"
          ></rti-simple-multiselect>
        }
      </rt-form-field>
    </div>
  </div>

  <rt-form-field [required]="!mainVacancyPhotoAttachment" margin-bottom>
    <rt-label>
      {{ 'rti.werken_in_een_hotel.create_posting.modal.main_vacancy_photo' | translate }}
    </rt-label>
    <div class="photo-size-hint" margin-bottom-small>
      {{ 'rti.werken_in_een_hotel.create_posting.modal.main_vacancy_photo_size_hint' | translate }}
    </div>
    <input
      #mainVacancyPhotoInput
      (change)="
        mainVacancyPhotoInputChanged(mainVacancyPhotoInput.files); mainVacancyPhotoInput.value = ''
      "
      accept="image/*"
      type="file"
      hidden
    />
    <div layout-vertical>
      <div layout>
        @if (!mainVacancyPhotoAttachment) {
          <rt-button (click)="mainVacancyPhotoInput.click()">
            <rt-icon name="file-upload"></rt-icon>
            <span>{{ 'rti.common.upload' | translate }}</span>
          </rt-button>
        }
      </div>
      @if (mainVacancyPhotoAttachment) {
        <rt-attachment-item
          [attachment]="mainVacancyPhotoAttachment"
          [hasDownloadAction]="false"
          [hasDeleteAction]="true"
          (deleteClick)="mainVacancyPhotoRemoved()"
        >
        </rt-attachment-item>
      }
      <div layout margin-top-small>
        @if (mainVacancyPhotoAttachment) {
          <rt-button variant="tertiary" (click)="mainVacancyPhotoInput.click()">
            <rt-icon name="file-upload"></rt-icon>
            <span>{{ 'rti.common.upload_new' | translate }}</span>
          </rt-button>
        }
      </div>
    </div>
    <rti-error-messages-wrapper [errors]="errorFields.mainVacancyPhoto">
    </rti-error-messages-wrapper>
  </rt-form-field>

  <rt-divider variant="line" padding-bottom-medium></rt-divider>

  @if (false) {
    <rt-form-field margin-bottom>
      <rt-label>
        {{ 'rti.werken_in_een_hotel.create_posting.modal.additional_photos' | translate }}
      </rt-label>
      <div class="photo-size-hint" margin-bottom-small>
        {{ 'rti.werken_in_een_hotel.create_posting.modal.additional_photos_size_hint' | translate }}
      </div>
      <input
        #additionalPhotosInput
        (change)="
          additionalPhotosInputChanged(additionalPhotosInput.files);
          additionalPhotosInput.value = ''
        "
        accept="image/*"
        type="file"
        hidden
      />
      <div layout-vertical>
        <div layout-horizontal>
          @for (
            attachment of postingAdditionalPhotoAttachments;
            track trackByAttachment($index, attachment)
          ) {
            <rt-attachment-item
              [attachment]="attachment"
              [hasDownloadAction]="false"
              [hasDeleteAction]="true"
              (deleteClick)="postingAdditionalPhotoRemoved(attachment.filename)"
            >
            </rt-attachment-item>
          }
          @for (
            attachment of state.draftAdditionalPhotoAttachments;
            track trackByAttachment(i, attachment);
            let i = $index
          ) {
            <rt-attachment-item
              [attachment]="attachment"
              [hasDownloadAction]="false"
              [hasDeleteAction]="true"
              (deleteClick)="draftAdditionalPhotoRemoved(i)"
            >
            </rt-attachment-item>
          }
        </div>
        <div layout margin-top-small>
          <rt-button
            variant="tertiary"
            [disabled]="additionalPhotosFull"
            (click)="additionalPhotosInput.click()"
          >
            <rt-icon name="file-upload"></rt-icon>
            <span>{{ 'rti.common.upload' | translate }}</span>
          </rt-button>
        </div>
      </div>
      <rti-error-messages-wrapper [errors]="errorFields.photos"> </rti-error-messages-wrapper>
    </rt-form-field>
  }

  <rt-form-field margin-bottom>
    <rt-label>
      {{ 'rti.werken_in_een_hotel.create_posting.modal.youtube_url' | translate }}
    </rt-label>
    <rt-input
      variant="rounded"
      [placeholder]="
        'rti.werken_in_een_hotel.create_posting.modal.youtube_url_placeholder' | translate
      "
      formControlName="youtubeUrl"
    ></rt-input>
  </rt-form-field>

  @if (false) {
    <div layout-horizontal margin-bottom>
      <rt-checkbox formControlName="publishOnOtherJobBoards">
        <span>
          {{
            'rti.werken_in_een_hotel.create_posting.modal.publish_on_other_job_boards' | translate
          }}
        </span>
      </rt-checkbox>
      <rt-icon-help
        [rtTooltip]="
          'rti.werken_in_een_hotel.create_posting.modal.publish_on_other_job_boards_help'
            | translate
        "
        margin-left-small-xx
      ></rt-icon-help>
    </div>
  }
  <rti-error-messages-wrapper [errors]="state.errors"> </rti-error-messages-wrapper>
</form>
